import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";
import { api } from "../../api";
import { APageHead, AMetric, ATable } from "../adminKit";

const COLORS = ["#3B82F6", "#8B5CF6", "#06b6d4"];
const tip = { background: "#12121a", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, color: "#fff", fontSize: 12 };

export default function AdminAI() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/ai").then(({ data }) => setD(data)); }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="space-y-5">
      <APageHead title="AI Operations & Analytics" subtitle="Operational metadata only — full prompts and report contents are never stored in analytics records." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <AMetric label="AI Conversations" value={d.ai_conversations} tone="blue" />
        <AMetric label="AI Messages" value={d.ai_messages} tone="purple" />
        <AMetric label="Reports Analyzed" value={d.reports_analyzed} tone="green" />
        <AMetric label="Disputes Generated" value={d.disputes_generated} tone="amber" />
        <AMetric label="Est. Tokens" value={d.est_tokens.toLocaleString()} />
        <AMetric label="Est. AI Cost" value={`$${d.est_cost}`} tone="green" />
        <AMetric label="Approaching Limit" value={d.approaching_limit} tone="amber" />
        <AMetric label="Exceeding / Failed" value={`${d.exceeding_limit} / ${d.failed_requests}`} tone="red" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="cc-card rounded-2xl p-5">
          <h3 className="cc-heading text-base font-500 text-white mb-4">AI Usage by Feature</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={d.by_feature}>
              <XAxis dataKey="name" tick={{ fill: "#64748b", fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: "#64748b", fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={tip} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
              <Bar dataKey="value" radius={[6, 6, 0, 0]}>{d.by_feature.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cc-card rounded-2xl p-5">
          <h3 className="cc-heading text-base font-500 text-white mb-3">Highest-Usage Users</h3>
          <ATable loading={false} rows={d.top_users} columns={[
            { key: "email", label: "User" },
            { key: "messages", label: "AI Messages", render: (r) => <span className="text-blue-300">{r.messages}</span> },
          ]} empty="No AI usage yet." />
        </div>
      </div>
    </div>
  );
}
